<nav class="navbar mb-5 bg-transparent navbar-light">
  <a class="navbar-brand m-auto" [routerLink]="['/']">
    <img src="../../../../../assets/images/logo_rnt-w.png" class="d-inline-block align-top img-responsive" height="32"
      alt="">
    Registro Nacional de Turismo
  </a>
  <div class="navbar-expand m-auto">
    <div class="navbar-nav flex-wrap">
      <a class="nav-item nav-link m-3" [routerLink]="['/contactenos']">
        <span>Contáctenos</span>
      </a>
      <a class="nav-item nav-link m-3" [routerLink]="['/faq']">
        <span>Más información</span>
      </a>
      <a *ngIf="!location.isCurrentPathEqualTo('/login')" class="nav-item nav-link m-3" [routerLink]="['/login']">
        <span>Iniciar sesión</span>
      </a>
      <a *ngIf="!location.isCurrentPathEqualTo('/registrar')" class="nav-item nav-link btn text-white m-3 pl-4 pr-4 menu-color-registrarse"
        [routerLink]="['/registrar']">
        <span>Registrarse</span>
      </a>
    </div>
  </div>
</nav>
<ng-content></ng-content>
<nav class="navbar navbar-light shadow-sm footer border-top menu-color-nav-footer p-2" [ngClass]="!location.isCurrentPathEqualTo('/home') ? 'fixed-bottom' : ''">
  <footer class="col-sm-12 text-center">
    <address class="text-white m-0 small mr-2">
      <a class="text-muted ol pointer" (click)="onOLClick()" style="cursor: pointer;">&copy; Confec&aacute;maras</a>
       | Red de c&aacute;maras de comercio - {{year|date:'y'}}</address>
  </footer>
</nav>
